<mat-card>
  <mat-card-content>
    <form>
    <p>
      <mat-form-field>
        <input type="text" matInput placeholder="Loan Ammount" name="ammount" [(ngModel)]="ammount">
      </mat-form-field>
    </p>

    <p>
      <mat-form-field>
        <input type="text" matInput placeholder="Deposit"  name="deposit" [(ngModel)]="deposit">
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="fill">
        <mat-label>Select a finance</mat-label>
        <mat-select name="month" [(ngModel)]="month">
          <mat-option *ngFor="let aprmonth of aprmonths" [value]="aprmonth.value">
            {{ aprmonth.value }} months <span class="aprcost">{{aprmonth.apr}}% APR</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <mat-card *ngIf="ammount && deposit && (deposit/ammount) < 0.1" class="mat-badge mat-raised-button mat-button-base mat-warn ">
      <small>Deposit ammount should be at least 10% from the loanable ammount.</small>
    </mat-card>

    <mat-divider></mat-divider>

    <table *ngIf="ammount && deposit && month && (deposit/ammount >= 0.1)" calss="">
      <tbody>
        <tr>
          <td>Number of Months</td>
          <td>: <span>{{month}}</span></td>
        </tr>
        <tr>
          <td>APR Percentage</td>
          <td>: <span>{{percentage}}%</span></td>
        </tr>
        <tr>
          <td>Monthly Payment</td>
          <td>: <span>£{{monthly_payment.toFixed(2)}}</span></td>
        </tr>
        <tr>
        <td>Credit amount</td>
        <td>: <span>£{{credit_ammount.toFixed(2)}}</span></td>
      </tr>
      <tr>
        <td>Cost of credit</td>
        <td>: <span>£{{cost_ammount.toFixed(2)}}</span></td>
      </tr>
      <tr>
        <td>Deposit</td>
        <td>: <span>£{{deposit_ammount.toFixed(2)}}</span></td>
      </tr>
      <tr>
        <td>Total repayable amount</td>
        <td>: <span>£{{total_ammount.toFixed(2)}}</span></td>
      </tr>
      </tbody>
    </table>


    </form>
  </mat-card-content>
</mat-card>
